import {TimeFrame} from "../models/TimeFrame";

export const PerformanceTimeFrameFilter = "performanceTimeFrame";

export function performanceTimeFrameFilter() {
    return (input: TimeFrame) => {
        return `trade-history.${input}`;
    };
}
